import(/* webpackMode: "eager" */ "/vercel/path0/src/app/Courses/page.tsx");
